import { render, staticRenderFns } from "./collect-email.vue?vue&type=template&id=ae57a202"
import script from "./collect-email.vue?vue&type=script&lang=js"
export * from "./collect-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.CommsManagerWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports